import { MediaContentShowcaseItem } from "@onnit-js/ui/components/module/MediaContentShowcase";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const IMG_PARAMS = "?q=20&fm=png&auto=compress,format";
const ingredients: MediaContentShowcaseItem[] = [
    {
        image: ``,
        imageWidth: 560,
        imageHeight: 560,
        title: "L-Arginine",
        summary: 'An amino acid that your body uses to synthesize nitric oxide.<span class="oui-sup">&dagger;</span>',
        detail: 'Helps maintain aerobic endurance and time to muscle exhaustion.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: ``,
        imageWidth: 560,
        imageHeight: 560,
        title: "L-Citrulline",
        summary: "An amino acid that was first found in watermelon.",
        detail:
            'Plays a role in providing nutrients to the muscles for normal muscle recovery and from high-intensity workouts.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: ``,
        imageWidth: 560,
        imageHeight: 560,
        alt: "Careflow Mango Fruit Powder",
        title: 'Careflow<span class="oui-sup">&reg;</span> Mango Fruit Powder',
        summary: "Derived from 100% Mango fruit powder.",
        detail: 'Supports blood circulation.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: ``,
        imageWidth: 560,
        imageHeight: 560,
        title: "Fermented Beetroot",
        summary: "Beets are a natural source of nitrates.",
        detail:
            'Provide a unique source of nitrates to round out the support for NO production in the body.<span class="oui-sup">&dagger;</span>',
    },
];

export default ingredients;
